import { render, staticRenderFns } from "./CouponsV2View.vue?vue&type=template&id=4f42b7b3&"
import script from "./CouponsV2View.vue?vue&type=script&lang=js&"
export * from "./CouponsV2View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports